/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
/* !!              AUTOMATIC GENERATION             !! */
/* !!           Do not touch this document          !! */
/* !!        If you want to modify something,       !! */
/* !! it's in /parameters or in scripts/generator/  !! */
/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
import { I18nKey } from "../i18n/i18n";

// EnumBuildingShape
export const ENUM_BUILDING_SHAPE = [
  "triangle_roof",
  "flat_roof",
  "custom_volume",
] as const;

export type EnumBuildingShape = (typeof ENUM_BUILDING_SHAPE)[number];

export const enumbuildingshapeToI18nKey: Record<EnumBuildingShape, I18nKey> = {
  //i18n.t("triangle-roof")
  triangle_roof: "triangle-roof",
  //i18n.t("flat-roof")
  flat_roof: "flat-roof",
  //i18n.t("custom-volume")
  custom_volume: "custom-volume",
};

export const ENUMBUILDINGSHAPE_OPTION: {
  value: EnumBuildingShape;
  label: I18nKey;
}[] = [
  {
    value: "triangle_roof",
    label: "triangle-roof",
  },
  {
    value: "flat_roof",
    label: "flat-roof",
  },
  {
    value: "custom_volume",
    label: "custom-volume",
  },
];

// EnumBuildingType
export const ENUM_BUILDING_TYPE = [
  "lateral",
  "hundred_percent_tunnel",
  "bilateral_tunnel",
  "high_extraction_tunnel",
  "statical",
  "stato_dynamic",
  "overpressure",
] as const;

export type EnumBuildingType = (typeof ENUM_BUILDING_TYPE)[number];

export const enumbuildingtypeToI18nKey: Record<EnumBuildingType, I18nKey> = {
  //i18n.t("lateral")
  lateral: "lateral",
  //i18n.t("hundred-percent-tunnel")
  hundred_percent_tunnel: "hundred-percent-tunnel",
  //i18n.t("bilateral-tunnel")
  bilateral_tunnel: "bilateral-tunnel",
  //i18n.t("high-extraction-tunnel")
  high_extraction_tunnel: "high-extraction-tunnel",
  //i18n.t("statical")
  statical: "statical",
  //i18n.t("stato-dynamic")
  stato_dynamic: "stato-dynamic",
  //i18n.t("overpressure")
  overpressure: "overpressure",
};

export const ENUMBUILDINGTYPE_OPTION: {
  value: EnumBuildingType;
  label: I18nKey;
}[] = [
  {
    value: "lateral",
    label: "lateral",
  },
  {
    value: "hundred_percent_tunnel",
    label: "hundred-percent-tunnel",
  },
  {
    value: "bilateral_tunnel",
    label: "bilateral-tunnel",
  },
  {
    value: "high_extraction_tunnel",
    label: "high-extraction-tunnel",
  },
  {
    value: "statical",
    label: "statical",
  },
  {
    value: "stato_dynamic",
    label: "stato-dynamic",
  },
  {
    value: "overpressure",
    label: "overpressure",
  },
];

// EnumCountry
export const ENUM_COUNTRY = [
  "AW",
  "AF",
  "AO",
  "AI",
  "AX",
  "AL",
  "AD",
  "AE",
  "AR",
  "AM",
  "AS",
  "AQ",
  "TF",
  "AG",
  "AU",
  "AT",
  "AZ",
  "BI",
  "BE",
  "BJ",
  "BQ",
  "BF",
  "BD",
  "BG",
  "BH",
  "BS",
  "BA",
  "BL",
  "BY",
  "BZ",
  "BM",
  "BO",
  "BR",
  "BB",
  "BN",
  "BT",
  "BV",
  "BW",
  "CF",
  "CA",
  "CC",
  "CH",
  "CL",
  "CN",
  "CI",
  "CM",
  "CD",
  "CG",
  "CK",
  "CO",
  "KM",
  "CV",
  "CR",
  "CU",
  "CW",
  "CX",
  "KY",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DM",
  "DK",
  "DO",
  "DZ",
  "EC",
  "EG",
  "ER",
  "EH",
  "ES",
  "EE",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FR",
  "FO",
  "FM",
  "GA",
  "GB",
  "GE",
  "GG",
  "GH",
  "GI",
  "GN",
  "GP",
  "GM",
  "GW",
  "GQ",
  "GR",
  "GD",
  "GL",
  "GT",
  "GF",
  "GU",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IM",
  "IN",
  "IO",
  "IE",
  "IR",
  "IQ",
  "IS",
  "IL",
  "IT",
  "JM",
  "JE",
  "JO",
  "JP",
  "KZ",
  "KE",
  "KG",
  "KH",
  "KI",
  "KN",
  "KR",
  "KW",
  "LA",
  "LB",
  "LR",
  "LY",
  "LC",
  "LI",
  "LK",
  "LS",
  "LT",
  "LU",
  "LV",
  "MO",
  "MF",
  "MA",
  "MC",
  "MD",
  "MG",
  "MV",
  "MX",
  "MH",
  "MK",
  "ML",
  "MT",
  "MM",
  "ME",
  "MN",
  "MP",
  "MZ",
  "MR",
  "MS",
  "MQ",
  "MU",
  "MW",
  "MY",
  "YT",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NU",
  "NL",
  "NO",
  "NP",
  "NR",
  "NZ",
  "OM",
  "PK",
  "PA",
  "PN",
  "PE",
  "PH",
  "PW",
  "PG",
  "PL",
  "PR",
  "KP",
  "PT",
  "PY",
  "PS",
  "PF",
  "QA",
  "RE",
  "RO",
  "RU",
  "RW",
  "SA",
  "SD",
  "SN",
  "SG",
  "GS",
  "SH",
  "SJ",
  "SB",
  "SL",
  "SV",
  "SM",
  "SO",
  "PM",
  "RS",
  "SS",
  "ST",
  "SR",
  "SK",
  "SI",
  "SE",
  "SZ",
  "SX",
  "SC",
  "SY",
  "TC",
  "TD",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TM",
  "TL",
  "TO",
  "TT",
  "TN",
  "TR",
  "TV",
  "TW",
  "TZ",
  "UG",
  "UA",
  "UM",
  "UY",
  "US",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "YE",
  "ZA",
  "ZM",
  "ZW",
] as const;

export type EnumCountry = (typeof ENUM_COUNTRY)[number];

export const enumcountryToI18nKey: Record<EnumCountry, I18nKey> = {
  //i18n.t("aw")
  AW: "aw",
  //i18n.t("af")
  AF: "af",
  //i18n.t("ao")
  AO: "ao",
  //i18n.t("ai")
  AI: "ai",
  //i18n.t("ax")
  AX: "ax",
  //i18n.t("al")
  AL: "al",
  //i18n.t("ad")
  AD: "ad",
  //i18n.t("ae")
  AE: "ae",
  //i18n.t("ar")
  AR: "ar",
  //i18n.t("am")
  AM: "am",
  //i18n.t("as")
  AS: "as",
  //i18n.t("aq")
  AQ: "aq",
  //i18n.t("tf")
  TF: "tf",
  //i18n.t("ag")
  AG: "ag",
  //i18n.t("au")
  AU: "au",
  //i18n.t("at")
  AT: "at",
  //i18n.t("az")
  AZ: "az",
  //i18n.t("bi")
  BI: "bi",
  //i18n.t("be")
  BE: "be",
  //i18n.t("bj")
  BJ: "bj",
  //i18n.t("bq")
  BQ: "bq",
  //i18n.t("bf")
  BF: "bf",
  //i18n.t("bd")
  BD: "bd",
  //i18n.t("bg")
  BG: "bg",
  //i18n.t("bh")
  BH: "bh",
  //i18n.t("bs")
  BS: "bs",
  //i18n.t("ba")
  BA: "ba",
  //i18n.t("bl")
  BL: "bl",
  //i18n.t("by")
  BY: "by",
  //i18n.t("bz")
  BZ: "bz",
  //i18n.t("bm")
  BM: "bm",
  //i18n.t("bo")
  BO: "bo",
  //i18n.t("br")
  BR: "br",
  //i18n.t("bb")
  BB: "bb",
  //i18n.t("bn")
  BN: "bn",
  //i18n.t("bt")
  BT: "bt",
  //i18n.t("bv")
  BV: "bv",
  //i18n.t("bw")
  BW: "bw",
  //i18n.t("cf")
  CF: "cf",
  //i18n.t("ca")
  CA: "ca",
  //i18n.t("cc")
  CC: "cc",
  //i18n.t("ch")
  CH: "ch",
  //i18n.t("cl")
  CL: "cl",
  //i18n.t("cn")
  CN: "cn",
  //i18n.t("ci")
  CI: "ci",
  //i18n.t("cm")
  CM: "cm",
  //i18n.t("cd")
  CD: "cd",
  //i18n.t("cg")
  CG: "cg",
  //i18n.t("ck")
  CK: "ck",
  //i18n.t("co")
  CO: "co",
  //i18n.t("km")
  KM: "km",
  //i18n.t("cv")
  CV: "cv",
  //i18n.t("cr")
  CR: "cr",
  //i18n.t("cu")
  CU: "cu",
  //i18n.t("cw")
  CW: "cw",
  //i18n.t("cx")
  CX: "cx",
  //i18n.t("ky")
  KY: "ky",
  //i18n.t("cy")
  CY: "cy",
  //i18n.t("cz")
  CZ: "cz",
  //i18n.t("de")
  DE: "de",
  //i18n.t("dj")
  DJ: "dj",
  //i18n.t("dm")
  DM: "dm",
  //i18n.t("dk")
  DK: "dk",
  //i18n.t("do")
  DO: "do",
  //i18n.t("dz")
  DZ: "dz",
  //i18n.t("ec")
  EC: "ec",
  //i18n.t("eg")
  EG: "eg",
  //i18n.t("er")
  ER: "er",
  //i18n.t("eh")
  EH: "eh",
  //i18n.t("es")
  ES: "es",
  //i18n.t("ee")
  EE: "ee",
  //i18n.t("et")
  ET: "et",
  //i18n.t("fi")
  FI: "fi",
  //i18n.t("fj")
  FJ: "fj",
  //i18n.t("fk")
  FK: "fk",
  //i18n.t("fr")
  FR: "fr",
  //i18n.t("fo")
  FO: "fo",
  //i18n.t("fm")
  FM: "fm",
  //i18n.t("ga")
  GA: "ga",
  //i18n.t("gb")
  GB: "gb",
  //i18n.t("ge")
  GE: "ge",
  //i18n.t("gg")
  GG: "gg",
  //i18n.t("gh")
  GH: "gh",
  //i18n.t("gi")
  GI: "gi",
  //i18n.t("gn")
  GN: "gn",
  //i18n.t("gp")
  GP: "gp",
  //i18n.t("gm")
  GM: "gm",
  //i18n.t("gw")
  GW: "gw",
  //i18n.t("gq")
  GQ: "gq",
  //i18n.t("gr")
  GR: "gr",
  //i18n.t("gd")
  GD: "gd",
  //i18n.t("gl")
  GL: "gl",
  //i18n.t("gt")
  GT: "gt",
  //i18n.t("gf")
  GF: "gf",
  //i18n.t("gu")
  GU: "gu",
  //i18n.t("gy")
  GY: "gy",
  //i18n.t("hk")
  HK: "hk",
  //i18n.t("hm")
  HM: "hm",
  //i18n.t("hn")
  HN: "hn",
  //i18n.t("hr")
  HR: "hr",
  //i18n.t("ht")
  HT: "ht",
  //i18n.t("hu")
  HU: "hu",
  //i18n.t("id")
  ID: "id",
  //i18n.t("im")
  IM: "im",
  //i18n.t("in")
  IN: "in",
  //i18n.t("io")
  IO: "io",
  //i18n.t("ie")
  IE: "ie",
  //i18n.t("ir")
  IR: "ir",
  //i18n.t("iq")
  IQ: "iq",
  //i18n.t("is")
  IS: "is",
  //i18n.t("il")
  IL: "il",
  //i18n.t("it")
  IT: "it",
  //i18n.t("jm")
  JM: "jm",
  //i18n.t("je")
  JE: "je",
  //i18n.t("jo")
  JO: "jo",
  //i18n.t("jp")
  JP: "jp",
  //i18n.t("kz")
  KZ: "kz",
  //i18n.t("ke")
  KE: "ke",
  //i18n.t("kg")
  KG: "kg",
  //i18n.t("kh")
  KH: "kh",
  //i18n.t("ki")
  KI: "ki",
  //i18n.t("kn")
  KN: "kn",
  //i18n.t("kr")
  KR: "kr",
  //i18n.t("kw")
  KW: "kw",
  //i18n.t("la")
  LA: "la",
  //i18n.t("lb")
  LB: "lb",
  //i18n.t("lr")
  LR: "lr",
  //i18n.t("ly")
  LY: "ly",
  //i18n.t("lc")
  LC: "lc",
  //i18n.t("li")
  LI: "li",
  //i18n.t("lk")
  LK: "lk",
  //i18n.t("ls")
  LS: "ls",
  //i18n.t("lt")
  LT: "lt",
  //i18n.t("lu")
  LU: "lu",
  //i18n.t("lv")
  LV: "lv",
  //i18n.t("mo")
  MO: "mo",
  //i18n.t("mf")
  MF: "mf",
  //i18n.t("ma")
  MA: "ma",
  //i18n.t("mc")
  MC: "mc",
  //i18n.t("md")
  MD: "md",
  //i18n.t("mg")
  MG: "mg",
  //i18n.t("mv")
  MV: "mv",
  //i18n.t("mx")
  MX: "mx",
  //i18n.t("mh")
  MH: "mh",
  //i18n.t("mk")
  MK: "mk",
  //i18n.t("ml")
  ML: "ml",
  //i18n.t("mt")
  MT: "mt",
  //i18n.t("mm")
  MM: "mm",
  //i18n.t("me")
  ME: "me",
  //i18n.t("mn")
  MN: "mn",
  //i18n.t("mp")
  MP: "mp",
  //i18n.t("mz")
  MZ: "mz",
  //i18n.t("mr")
  MR: "mr",
  //i18n.t("ms")
  MS: "ms",
  //i18n.t("mq")
  MQ: "mq",
  //i18n.t("mu")
  MU: "mu",
  //i18n.t("mw")
  MW: "mw",
  //i18n.t("my")
  MY: "my",
  //i18n.t("yt")
  YT: "yt",
  //i18n.t("na")
  NA: "na",
  //i18n.t("nc")
  NC: "nc",
  //i18n.t("ne")
  NE: "ne",
  //i18n.t("nf")
  NF: "nf",
  //i18n.t("ng")
  NG: "ng",
  //i18n.t("ni")
  NI: "ni",
  //i18n.t("nu")
  NU: "nu",
  //i18n.t("nl")
  NL: "nl",
  //i18n.t("no")
  NO: "no",
  //i18n.t("np")
  NP: "np",
  //i18n.t("nr")
  NR: "nr",
  //i18n.t("nz")
  NZ: "nz",
  //i18n.t("om")
  OM: "om",
  //i18n.t("pk")
  PK: "pk",
  //i18n.t("pa")
  PA: "pa",
  //i18n.t("pn")
  PN: "pn",
  //i18n.t("pe")
  PE: "pe",
  //i18n.t("ph")
  PH: "ph",
  //i18n.t("pw")
  PW: "pw",
  //i18n.t("pg")
  PG: "pg",
  //i18n.t("pl")
  PL: "pl",
  //i18n.t("pr")
  PR: "pr",
  //i18n.t("kp")
  KP: "kp",
  //i18n.t("pt")
  PT: "pt",
  //i18n.t("py")
  PY: "py",
  //i18n.t("ps")
  PS: "ps",
  //i18n.t("pf")
  PF: "pf",
  //i18n.t("qa")
  QA: "qa",
  //i18n.t("re")
  RE: "re",
  //i18n.t("ro")
  RO: "ro",
  //i18n.t("ru")
  RU: "ru",
  //i18n.t("rw")
  RW: "rw",
  //i18n.t("sa")
  SA: "sa",
  //i18n.t("sd")
  SD: "sd",
  //i18n.t("sn")
  SN: "sn",
  //i18n.t("sg")
  SG: "sg",
  //i18n.t("gs")
  GS: "gs",
  //i18n.t("sh")
  SH: "sh",
  //i18n.t("sj")
  SJ: "sj",
  //i18n.t("sb")
  SB: "sb",
  //i18n.t("sl")
  SL: "sl",
  //i18n.t("sv")
  SV: "sv",
  //i18n.t("sm")
  SM: "sm",
  //i18n.t("so")
  SO: "so",
  //i18n.t("pm")
  PM: "pm",
  //i18n.t("rs")
  RS: "rs",
  //i18n.t("ss")
  SS: "ss",
  //i18n.t("st")
  ST: "st",
  //i18n.t("sr")
  SR: "sr",
  //i18n.t("sk")
  SK: "sk",
  //i18n.t("si")
  SI: "si",
  //i18n.t("se")
  SE: "se",
  //i18n.t("sz")
  SZ: "sz",
  //i18n.t("sx")
  SX: "sx",
  //i18n.t("sc")
  SC: "sc",
  //i18n.t("sy")
  SY: "sy",
  //i18n.t("tc")
  TC: "tc",
  //i18n.t("td")
  TD: "td",
  //i18n.t("tg")
  TG: "tg",
  //i18n.t("th")
  TH: "th",
  //i18n.t("tj")
  TJ: "tj",
  //i18n.t("tk")
  TK: "tk",
  //i18n.t("tm")
  TM: "tm",
  //i18n.t("tl")
  TL: "tl",
  //i18n.t("to")
  TO: "to",
  //i18n.t("tt")
  TT: "tt",
  //i18n.t("tn")
  TN: "tn",
  //i18n.t("tr")
  TR: "tr",
  //i18n.t("tv")
  TV: "tv",
  //i18n.t("tw")
  TW: "tw",
  //i18n.t("tz")
  TZ: "tz",
  //i18n.t("ug")
  UG: "ug",
  //i18n.t("ua")
  UA: "ua",
  //i18n.t("um")
  UM: "um",
  //i18n.t("uy")
  UY: "uy",
  //i18n.t("us")
  US: "us",
  //i18n.t("uz")
  UZ: "uz",
  //i18n.t("va")
  VA: "va",
  //i18n.t("vc")
  VC: "vc",
  //i18n.t("ve")
  VE: "ve",
  //i18n.t("vg")
  VG: "vg",
  //i18n.t("vi")
  VI: "vi",
  //i18n.t("vn")
  VN: "vn",
  //i18n.t("vu")
  VU: "vu",
  //i18n.t("wf")
  WF: "wf",
  //i18n.t("ws")
  WS: "ws",
  //i18n.t("ye")
  YE: "ye",
  //i18n.t("za")
  ZA: "za",
  //i18n.t("zm")
  ZM: "zm",
  //i18n.t("zw")
  ZW: "zw",
};

export const ENUMCOUNTRY_OPTION: {
  value: EnumCountry;
  label: I18nKey;
}[] = [
  {
    value: "AW",
    label: "aw",
  },
  {
    value: "AF",
    label: "af",
  },
  {
    value: "AO",
    label: "ao",
  },
  {
    value: "AI",
    label: "ai",
  },
  {
    value: "AX",
    label: "ax",
  },
  {
    value: "AL",
    label: "al",
  },
  {
    value: "AD",
    label: "ad",
  },
  {
    value: "AE",
    label: "ae",
  },
  {
    value: "AR",
    label: "ar",
  },
  {
    value: "AM",
    label: "am",
  },
  {
    value: "AS",
    label: "as",
  },
  {
    value: "AQ",
    label: "aq",
  },
  {
    value: "TF",
    label: "tf",
  },
  {
    value: "AG",
    label: "ag",
  },
  {
    value: "AU",
    label: "au",
  },
  {
    value: "AT",
    label: "at",
  },
  {
    value: "AZ",
    label: "az",
  },
  {
    value: "BI",
    label: "bi",
  },
  {
    value: "BE",
    label: "be",
  },
  {
    value: "BJ",
    label: "bj",
  },
  {
    value: "BQ",
    label: "bq",
  },
  {
    value: "BF",
    label: "bf",
  },
  {
    value: "BD",
    label: "bd",
  },
  {
    value: "BG",
    label: "bg",
  },
  {
    value: "BH",
    label: "bh",
  },
  {
    value: "BS",
    label: "bs",
  },
  {
    value: "BA",
    label: "ba",
  },
  {
    value: "BL",
    label: "bl",
  },
  {
    value: "BY",
    label: "by",
  },
  {
    value: "BZ",
    label: "bz",
  },
  {
    value: "BM",
    label: "bm",
  },
  {
    value: "BO",
    label: "bo",
  },
  {
    value: "BR",
    label: "br",
  },
  {
    value: "BB",
    label: "bb",
  },
  {
    value: "BN",
    label: "bn",
  },
  {
    value: "BT",
    label: "bt",
  },
  {
    value: "BV",
    label: "bv",
  },
  {
    value: "BW",
    label: "bw",
  },
  {
    value: "CF",
    label: "cf",
  },
  {
    value: "CA",
    label: "ca",
  },
  {
    value: "CC",
    label: "cc",
  },
  {
    value: "CH",
    label: "ch",
  },
  {
    value: "CL",
    label: "cl",
  },
  {
    value: "CN",
    label: "cn",
  },
  {
    value: "CI",
    label: "ci",
  },
  {
    value: "CM",
    label: "cm",
  },
  {
    value: "CD",
    label: "cd",
  },
  {
    value: "CG",
    label: "cg",
  },
  {
    value: "CK",
    label: "ck",
  },
  {
    value: "CO",
    label: "co",
  },
  {
    value: "KM",
    label: "km",
  },
  {
    value: "CV",
    label: "cv",
  },
  {
    value: "CR",
    label: "cr",
  },
  {
    value: "CU",
    label: "cu",
  },
  {
    value: "CW",
    label: "cw",
  },
  {
    value: "CX",
    label: "cx",
  },
  {
    value: "KY",
    label: "ky",
  },
  {
    value: "CY",
    label: "cy",
  },
  {
    value: "CZ",
    label: "cz",
  },
  {
    value: "DE",
    label: "de",
  },
  {
    value: "DJ",
    label: "dj",
  },
  {
    value: "DM",
    label: "dm",
  },
  {
    value: "DK",
    label: "dk",
  },
  {
    value: "DO",
    label: "do",
  },
  {
    value: "DZ",
    label: "dz",
  },
  {
    value: "EC",
    label: "ec",
  },
  {
    value: "EG",
    label: "eg",
  },
  {
    value: "ER",
    label: "er",
  },
  {
    value: "EH",
    label: "eh",
  },
  {
    value: "ES",
    label: "es",
  },
  {
    value: "EE",
    label: "ee",
  },
  {
    value: "ET",
    label: "et",
  },
  {
    value: "FI",
    label: "fi",
  },
  {
    value: "FJ",
    label: "fj",
  },
  {
    value: "FK",
    label: "fk",
  },
  {
    value: "FR",
    label: "fr",
  },
  {
    value: "FO",
    label: "fo",
  },
  {
    value: "FM",
    label: "fm",
  },
  {
    value: "GA",
    label: "ga",
  },
  {
    value: "GB",
    label: "gb",
  },
  {
    value: "GE",
    label: "ge",
  },
  {
    value: "GG",
    label: "gg",
  },
  {
    value: "GH",
    label: "gh",
  },
  {
    value: "GI",
    label: "gi",
  },
  {
    value: "GN",
    label: "gn",
  },
  {
    value: "GP",
    label: "gp",
  },
  {
    value: "GM",
    label: "gm",
  },
  {
    value: "GW",
    label: "gw",
  },
  {
    value: "GQ",
    label: "gq",
  },
  {
    value: "GR",
    label: "gr",
  },
  {
    value: "GD",
    label: "gd",
  },
  {
    value: "GL",
    label: "gl",
  },
  {
    value: "GT",
    label: "gt",
  },
  {
    value: "GF",
    label: "gf",
  },
  {
    value: "GU",
    label: "gu",
  },
  {
    value: "GY",
    label: "gy",
  },
  {
    value: "HK",
    label: "hk",
  },
  {
    value: "HM",
    label: "hm",
  },
  {
    value: "HN",
    label: "hn",
  },
  {
    value: "HR",
    label: "hr",
  },
  {
    value: "HT",
    label: "ht",
  },
  {
    value: "HU",
    label: "hu",
  },
  {
    value: "ID",
    label: "id",
  },
  {
    value: "IM",
    label: "im",
  },
  {
    value: "IN",
    label: "in",
  },
  {
    value: "IO",
    label: "io",
  },
  {
    value: "IE",
    label: "ie",
  },
  {
    value: "IR",
    label: "ir",
  },
  {
    value: "IQ",
    label: "iq",
  },
  {
    value: "IS",
    label: "is",
  },
  {
    value: "IL",
    label: "il",
  },
  {
    value: "IT",
    label: "it",
  },
  {
    value: "JM",
    label: "jm",
  },
  {
    value: "JE",
    label: "je",
  },
  {
    value: "JO",
    label: "jo",
  },
  {
    value: "JP",
    label: "jp",
  },
  {
    value: "KZ",
    label: "kz",
  },
  {
    value: "KE",
    label: "ke",
  },
  {
    value: "KG",
    label: "kg",
  },
  {
    value: "KH",
    label: "kh",
  },
  {
    value: "KI",
    label: "ki",
  },
  {
    value: "KN",
    label: "kn",
  },
  {
    value: "KR",
    label: "kr",
  },
  {
    value: "KW",
    label: "kw",
  },
  {
    value: "LA",
    label: "la",
  },
  {
    value: "LB",
    label: "lb",
  },
  {
    value: "LR",
    label: "lr",
  },
  {
    value: "LY",
    label: "ly",
  },
  {
    value: "LC",
    label: "lc",
  },
  {
    value: "LI",
    label: "li",
  },
  {
    value: "LK",
    label: "lk",
  },
  {
    value: "LS",
    label: "ls",
  },
  {
    value: "LT",
    label: "lt",
  },
  {
    value: "LU",
    label: "lu",
  },
  {
    value: "LV",
    label: "lv",
  },
  {
    value: "MO",
    label: "mo",
  },
  {
    value: "MF",
    label: "mf",
  },
  {
    value: "MA",
    label: "ma",
  },
  {
    value: "MC",
    label: "mc",
  },
  {
    value: "MD",
    label: "md",
  },
  {
    value: "MG",
    label: "mg",
  },
  {
    value: "MV",
    label: "mv",
  },
  {
    value: "MX",
    label: "mx",
  },
  {
    value: "MH",
    label: "mh",
  },
  {
    value: "MK",
    label: "mk",
  },
  {
    value: "ML",
    label: "ml",
  },
  {
    value: "MT",
    label: "mt",
  },
  {
    value: "MM",
    label: "mm",
  },
  {
    value: "ME",
    label: "me",
  },
  {
    value: "MN",
    label: "mn",
  },
  {
    value: "MP",
    label: "mp",
  },
  {
    value: "MZ",
    label: "mz",
  },
  {
    value: "MR",
    label: "mr",
  },
  {
    value: "MS",
    label: "ms",
  },
  {
    value: "MQ",
    label: "mq",
  },
  {
    value: "MU",
    label: "mu",
  },
  {
    value: "MW",
    label: "mw",
  },
  {
    value: "MY",
    label: "my",
  },
  {
    value: "YT",
    label: "yt",
  },
  {
    value: "NA",
    label: "na",
  },
  {
    value: "NC",
    label: "nc",
  },
  {
    value: "NE",
    label: "ne",
  },
  {
    value: "NF",
    label: "nf",
  },
  {
    value: "NG",
    label: "ng",
  },
  {
    value: "NI",
    label: "ni",
  },
  {
    value: "NU",
    label: "nu",
  },
  {
    value: "NL",
    label: "nl",
  },
  {
    value: "NO",
    label: "no",
  },
  {
    value: "NP",
    label: "np",
  },
  {
    value: "NR",
    label: "nr",
  },
  {
    value: "NZ",
    label: "nz",
  },
  {
    value: "OM",
    label: "om",
  },
  {
    value: "PK",
    label: "pk",
  },
  {
    value: "PA",
    label: "pa",
  },
  {
    value: "PN",
    label: "pn",
  },
  {
    value: "PE",
    label: "pe",
  },
  {
    value: "PH",
    label: "ph",
  },
  {
    value: "PW",
    label: "pw",
  },
  {
    value: "PG",
    label: "pg",
  },
  {
    value: "PL",
    label: "pl",
  },
  {
    value: "PR",
    label: "pr",
  },
  {
    value: "KP",
    label: "kp",
  },
  {
    value: "PT",
    label: "pt",
  },
  {
    value: "PY",
    label: "py",
  },
  {
    value: "PS",
    label: "ps",
  },
  {
    value: "PF",
    label: "pf",
  },
  {
    value: "QA",
    label: "qa",
  },
  {
    value: "RE",
    label: "re",
  },
  {
    value: "RO",
    label: "ro",
  },
  {
    value: "RU",
    label: "ru",
  },
  {
    value: "RW",
    label: "rw",
  },
  {
    value: "SA",
    label: "sa",
  },
  {
    value: "SD",
    label: "sd",
  },
  {
    value: "SN",
    label: "sn",
  },
  {
    value: "SG",
    label: "sg",
  },
  {
    value: "GS",
    label: "gs",
  },
  {
    value: "SH",
    label: "sh",
  },
  {
    value: "SJ",
    label: "sj",
  },
  {
    value: "SB",
    label: "sb",
  },
  {
    value: "SL",
    label: "sl",
  },
  {
    value: "SV",
    label: "sv",
  },
  {
    value: "SM",
    label: "sm",
  },
  {
    value: "SO",
    label: "so",
  },
  {
    value: "PM",
    label: "pm",
  },
  {
    value: "RS",
    label: "rs",
  },
  {
    value: "SS",
    label: "ss",
  },
  {
    value: "ST",
    label: "st",
  },
  {
    value: "SR",
    label: "sr",
  },
  {
    value: "SK",
    label: "sk",
  },
  {
    value: "SI",
    label: "si",
  },
  {
    value: "SE",
    label: "se",
  },
  {
    value: "SZ",
    label: "sz",
  },
  {
    value: "SX",
    label: "sx",
  },
  {
    value: "SC",
    label: "sc",
  },
  {
    value: "SY",
    label: "sy",
  },
  {
    value: "TC",
    label: "tc",
  },
  {
    value: "TD",
    label: "td",
  },
  {
    value: "TG",
    label: "tg",
  },
  {
    value: "TH",
    label: "th",
  },
  {
    value: "TJ",
    label: "tj",
  },
  {
    value: "TK",
    label: "tk",
  },
  {
    value: "TM",
    label: "tm",
  },
  {
    value: "TL",
    label: "tl",
  },
  {
    value: "TO",
    label: "to",
  },
  {
    value: "TT",
    label: "tt",
  },
  {
    value: "TN",
    label: "tn",
  },
  {
    value: "TR",
    label: "tr",
  },
  {
    value: "TV",
    label: "tv",
  },
  {
    value: "TW",
    label: "tw",
  },
  {
    value: "TZ",
    label: "tz",
  },
  {
    value: "UG",
    label: "ug",
  },
  {
    value: "UA",
    label: "ua",
  },
  {
    value: "UM",
    label: "um",
  },
  {
    value: "UY",
    label: "uy",
  },
  {
    value: "US",
    label: "us",
  },
  {
    value: "UZ",
    label: "uz",
  },
  {
    value: "VA",
    label: "va",
  },
  {
    value: "VC",
    label: "vc",
  },
  {
    value: "VE",
    label: "ve",
  },
  {
    value: "VG",
    label: "vg",
  },
  {
    value: "VI",
    label: "vi",
  },
  {
    value: "VN",
    label: "vn",
  },
  {
    value: "VU",
    label: "vu",
  },
  {
    value: "WF",
    label: "wf",
  },
  {
    value: "WS",
    label: "ws",
  },
  {
    value: "YE",
    label: "ye",
  },
  {
    value: "ZA",
    label: "za",
  },
  {
    value: "ZM",
    label: "zm",
  },
  {
    value: "ZW",
    label: "zw",
  },
];

// EnumDeviceStatus
export const ENUM_DEVICE_STATUS = [
  "active",
  "warning",
  "critical",
  "inactive",
] as const;

export type EnumDeviceStatus = (typeof ENUM_DEVICE_STATUS)[number];

export const enumdevicestatusToI18nKey: Record<EnumDeviceStatus, I18nKey> = {
  //i18n.t("active")
  active: "active",
  //i18n.t("warning")
  warning: "warning",
  //i18n.t("critical")
  critical: "critical",
  //i18n.t("inactive")
  inactive: "inactive",
};

export const ENUMDEVICESTATUS_OPTION: {
  value: EnumDeviceStatus;
  label: I18nKey;
}[] = [
  {
    value: "active",
    label: "active",
  },
  {
    value: "warning",
    label: "warning",
  },
  {
    value: "critical",
    label: "critical",
  },
  {
    value: "inactive",
    label: "inactive",
  },
];

// EnumDeviceType
export const ENUM_DEVICE_TYPE = [
  "serenity",
  "avitouch",
  "avibox",
  "labelbox",
  "vigebox",
] as const;

export type EnumDeviceType = (typeof ENUM_DEVICE_TYPE)[number];

export const enumdevicetypeToI18nKey: Record<EnumDeviceType, I18nKey> = {
  //i18n.t("serenity")
  serenity: "serenity",
  //i18n.t("avitouch")
  avitouch: "avitouch",
  //i18n.t("avibox")
  avibox: "avibox",
  //i18n.t("labelbox")
  labelbox: "labelbox",
  //i18n.t("vigebox")
  vigebox: "vigebox",
};

export const ENUMDEVICETYPE_OPTION: {
  value: EnumDeviceType;
  label: I18nKey;
}[] = [
  {
    value: "serenity",
    label: "serenity",
  },
  {
    value: "avitouch",
    label: "avitouch",
  },
  {
    value: "avibox",
    label: "avibox",
  },
  {
    value: "labelbox",
    label: "labelbox",
  },
  {
    value: "vigebox",
    label: "vigebox",
  },
];

// EnumLanguage
export const ENUM_LANGUAGE = ["fr_FR", "en_GB", "es_ES", "zh_CN"] as const;

export type EnumLanguage = (typeof ENUM_LANGUAGE)[number];

export const enumlanguageToI18nKey: Record<EnumLanguage, I18nKey> = {
  //i18n.t("fr-fr")
  fr_FR: "fr-fr",
  //i18n.t("en-gb")
  en_GB: "en-gb",
  //i18n.t("es-es")
  es_ES: "es-es",
  //i18n.t("zh-cn")
  zh_CN: "zh-cn",
};

export const ENUMLANGUAGE_OPTION: {
  value: EnumLanguage;
  label: I18nKey;
}[] = [
  {
    value: "fr_FR",
    label: "fr-fr",
  },
  {
    value: "en_GB",
    label: "en-gb",
  },
  {
    value: "es_ES",
    label: "es-es",
  },
  {
    value: "zh_CN",
    label: "zh-cn",
  },
];

// EnumProductionType
export const ENUM_PRODUCTION_TYPE = ["broiler", "layer", "breeder"] as const;

export type EnumProductionType = (typeof ENUM_PRODUCTION_TYPE)[number];

export const enumproductiontypeToI18nKey: Record<EnumProductionType, I18nKey> =
  {
    //i18n.t("broiler")
    broiler: "broiler",
    //i18n.t("layer")
    layer: "layer",
    //i18n.t("breeder")
    breeder: "breeder",
  };

export const ENUMPRODUCTIONTYPE_OPTION: {
  value: EnumProductionType;
  label: I18nKey;
}[] = [
  {
    value: "broiler",
    label: "broiler",
  },
  {
    value: "layer",
    label: "layer",
  },
  {
    value: "breeder",
    label: "breeder",
  },
];

// EnumUserRight
export const ENUM_USER_RIGHT = ["admin", "maintainer", "viewer"] as const;

export type EnumUserRight = (typeof ENUM_USER_RIGHT)[number];

export const enumuserrightToI18nKey: Record<EnumUserRight, I18nKey> = {
  //i18n.t("admin")
  admin: "admin",
  //i18n.t("maintainer")
  maintainer: "maintainer",
  //i18n.t("viewer")
  viewer: "viewer",
};

export const ENUMUSERRIGHT_OPTION: {
  value: EnumUserRight;
  label: I18nKey;
}[] = [
  {
    value: "admin",
    label: "admin",
  },
  {
    value: "maintainer",
    label: "maintainer",
  },
  {
    value: "viewer",
    label: "viewer",
  },
];

// EnumUserType
export const ENUM_USER_TYPE = [
  "admin",
  "psc",
  "breeder",
  "breeder_assistant",
  "installer",
  "installer_assistant",
  "group",
  "group_assistant",
] as const;

export type EnumUserType = (typeof ENUM_USER_TYPE)[number];

export const enumusertypeToI18nKey: Record<EnumUserType, I18nKey> = {
  //i18n.t("admin")
  admin: "admin",
  //i18n.t("psc")
  psc: "psc",
  //i18n.t("breeder")
  breeder: "breeder",
  //i18n.t("breeder-assistant")
  breeder_assistant: "breeder-assistant",
  //i18n.t("installer")
  installer: "installer",
  //i18n.t("installer-assistant")
  installer_assistant: "installer-assistant",
  //i18n.t("group")
  group: "group",
  //i18n.t("group-assistant")
  group_assistant: "group-assistant",
};

export const ENUMUSERTYPE_OPTION: {
  value: EnumUserType;
  label: I18nKey;
}[] = [
  {
    value: "admin",
    label: "admin",
  },
  {
    value: "psc",
    label: "psc",
  },
  {
    value: "breeder",
    label: "breeder",
  },
  {
    value: "breeder_assistant",
    label: "breeder-assistant",
  },
  {
    value: "installer",
    label: "installer",
  },
  {
    value: "installer_assistant",
    label: "installer-assistant",
  },
  {
    value: "group",
    label: "group",
  },
  {
    value: "group_assistant",
    label: "group-assistant",
  },
];

// EnumSection
export const ENUM_SECTION = [
  "section_dashboard",
  "section_account",
  "section_accounts",
  "section_breeding",
  "section_breedings",
  "section_building",
  "section_breeding_building",
  "section_company",
  "section_devices",
  "section_device",
  "section_my_device",
  "section_profile",
  "section_installer",
  "section_partnerships",
  "section_charts",
  "section_history",
  "section_regulators",
  "section_analysis",
  "section_collaborators",
] as const;

export type EnumSection = (typeof ENUM_SECTION)[number];

export const enumsectionToI18nKey: Record<EnumSection, I18nKey> = {
  //i18n.t("section-dashboard")
  section_dashboard: "section-dashboard",
  //i18n.t("section-account")
  section_account: "section-account",
  //i18n.t("section-accounts")
  section_accounts: "section-accounts",
  //i18n.t("section-breeding")
  section_breeding: "section-breeding",
  //i18n.t("section-breedings")
  section_breedings: "section-breedings",
  //i18n.t("section-building")
  section_building: "section-building",
  //i18n.t("section-breeding-building")
  section_breeding_building: "section-breeding-building",
  //i18n.t("section-company")
  section_company: "section-company",
  //i18n.t("section-devices")
  section_devices: "section-devices",
  //i18n.t("section-device")
  section_device: "section-device",
  //i18n.t("section-my-device")
  section_my_device: "section-my-device",
  //i18n.t("section-profile")
  section_profile: "section-profile",
  //i18n.t("section-installer")
  section_installer: "section-installer",
  //i18n.t("section-partnerships")
  section_partnerships: "section-partnerships",
  //i18n.t("section-charts")
  section_charts: "section-charts",
  //i18n.t("section-history")
  section_history: "section-history",
  //i18n.t("section-regulators")
  section_regulators: "section-regulators",
  //i18n.t("section-analysis")
  section_analysis: "section-analysis",
  //i18n.t("section-collaborators")
  section_collaborators: "section-collaborators",
};

export const ENUMSECTION_OPTION: {
  value: EnumSection;
  label: I18nKey;
}[] = [
  {
    value: "section_dashboard",
    label: "section-dashboard",
  },
  {
    value: "section_account",
    label: "section-account",
  },
  {
    value: "section_accounts",
    label: "section-accounts",
  },
  {
    value: "section_breeding",
    label: "section-breeding",
  },
  {
    value: "section_breedings",
    label: "section-breedings",
  },
  {
    value: "section_building",
    label: "section-building",
  },
  {
    value: "section_breeding_building",
    label: "section-breeding-building",
  },
  {
    value: "section_company",
    label: "section-company",
  },
  {
    value: "section_devices",
    label: "section-devices",
  },
  {
    value: "section_device",
    label: "section-device",
  },
  {
    value: "section_my_device",
    label: "section-my-device",
  },
  {
    value: "section_profile",
    label: "section-profile",
  },
  {
    value: "section_installer",
    label: "section-installer",
  },
  {
    value: "section_partnerships",
    label: "section-partnerships",
  },
  {
    value: "section_charts",
    label: "section-charts",
  },
  {
    value: "section_history",
    label: "section-history",
  },
  {
    value: "section_regulators",
    label: "section-regulators",
  },
  {
    value: "section_analysis",
    label: "section-analysis",
  },
  {
    value: "section_collaborators",
    label: "section-collaborators",
  },
];

// EnumSqlMode
export const ENUM_SQL_MODE = ["INSERT", "UPDATE"] as const;

export type EnumSqlMode = (typeof ENUM_SQL_MODE)[number];

export const enumsqlmodeToI18nKey: Record<EnumSqlMode, I18nKey> = {
  //i18n.t("insert")
  INSERT: "insert",
  //i18n.t("update")
  UPDATE: "update",
};

export const ENUMSQLMODE_OPTION: {
  value: EnumSqlMode;
  label: I18nKey;
}[] = [
  {
    value: "INSERT",
    label: "insert",
  },
  {
    value: "UPDATE",
    label: "update",
  },
];

// EnumPartnershipType
export const ENUM_PARTNERSHIP_TYPE = ["installer", "group"] as const;

export type EnumPartnershipType = (typeof ENUM_PARTNERSHIP_TYPE)[number];

export const enumpartnershiptypeToI18nKey: Record<
  EnumPartnershipType,
  I18nKey
> = {
  //i18n.t("installer")
  installer: "installer",
  //i18n.t("group")
  group: "group",
};

export const ENUMPARTNERSHIPTYPE_OPTION: {
  value: EnumPartnershipType;
  label: I18nKey;
}[] = [
  {
    value: "installer",
    label: "installer",
  },
  {
    value: "group",
    label: "group",
  },
];

// EnumPartnershipStatus
export const ENUM_PARTNERSHIP_STATUS = [
  "pending",
  "accepted",
  "refused",
] as const;

export type EnumPartnershipStatus = (typeof ENUM_PARTNERSHIP_STATUS)[number];

export const enumpartnershipstatusToI18nKey: Record<
  EnumPartnershipStatus,
  I18nKey
> = {
  //i18n.t("pending")
  pending: "pending",
  //i18n.t("accepted")
  accepted: "accepted",
  //i18n.t("refused")
  refused: "refused",
};

export const ENUMPARTNERSHIPSTATUS_OPTION: {
  value: EnumPartnershipStatus;
  label: I18nKey;
}[] = [
  {
    value: "pending",
    label: "pending",
  },
  {
    value: "accepted",
    label: "accepted",
  },
  {
    value: "refused",
    label: "refused",
  },
];

// EnumShareResourceType
export const ENUM_SHARE_RESOURCE_TYPE = [
  "device",
  "building",
  "breeding",
] as const;

export type EnumShareResourceType = (typeof ENUM_SHARE_RESOURCE_TYPE)[number];

export const enumshareresourcetypeToI18nKey: Record<
  EnumShareResourceType,
  I18nKey
> = {
  //i18n.t("device")
  device: "device",
  //i18n.t("building")
  building: "building",
  //i18n.t("breeding")
  breeding: "breeding",
};

export const ENUMSHARERESOURCETYPE_OPTION: {
  value: EnumShareResourceType;
  label: I18nKey;
}[] = [
  {
    value: "device",
    label: "device",
  },
  {
    value: "building",
    label: "building",
  },
  {
    value: "breeding",
    label: "breeding",
  },
];

// EnumRemoteConnectionKind
export const ENUM_REMOTE_CONNECTION_KIND = [
  "remote_serenity",
  "remote_legacy_vnc",
] as const;

export type EnumRemoteConnectionKind =
  (typeof ENUM_REMOTE_CONNECTION_KIND)[number];

export const enumremoteconnectionkindToI18nKey: Record<
  EnumRemoteConnectionKind,
  I18nKey
> = {
  //i18n.t("remote-serenity")
  remote_serenity: "remote-serenity",
  //i18n.t("remote-legacy-vnc")
  remote_legacy_vnc: "remote-legacy-vnc",
};

export const ENUMREMOTECONNECTIONKIND_OPTION: {
  value: EnumRemoteConnectionKind;
  label: I18nKey;
}[] = [
  {
    value: "remote_serenity",
    label: "remote-serenity",
  },
  {
    value: "remote_legacy_vnc",
    label: "remote-legacy-vnc",
  },
];

// EnumRemoteConnectionStatus
export const ENUM_REMOTE_CONNECTION_STATUS = [
  "granted",
  "denied",
  "not_found",
  "unavailable",
  "error",
] as const;

export type EnumRemoteConnectionStatus =
  (typeof ENUM_REMOTE_CONNECTION_STATUS)[number];

export const enumremoteconnectionstatusToI18nKey: Record<
  EnumRemoteConnectionStatus,
  I18nKey
> = {
  //i18n.t("granted")
  granted: "granted",
  //i18n.t("denied")
  denied: "denied",
  //i18n.t("not-found")
  not_found: "not-found",
  //i18n.t("unavailable")
  unavailable: "unavailable",
  //i18n.t("error")
  error: "error",
};

export const ENUMREMOTECONNECTIONSTATUS_OPTION: {
  value: EnumRemoteConnectionStatus;
  label: I18nKey;
}[] = [
  {
    value: "granted",
    label: "granted",
  },
  {
    value: "denied",
    label: "denied",
  },
  {
    value: "not_found",
    label: "not-found",
  },
  {
    value: "unavailable",
    label: "unavailable",
  },
  {
    value: "error",
    label: "error",
  },
];

// EnumLoginStatus
export const ENUM_LOGIN_STATUS = [
  "login_success",
  "login_bad_credentials",
  "login_unknown_account",
  "login_error",
] as const;

export type EnumLoginStatus = (typeof ENUM_LOGIN_STATUS)[number];

export const enumloginstatusToI18nKey: Record<EnumLoginStatus, I18nKey> = {
  //i18n.t("login-success")
  login_success: "login-success",
  //i18n.t("login-bad-credentials")
  login_bad_credentials: "login-bad-credentials",
  //i18n.t("login-unknown-account")
  login_unknown_account: "login-unknown-account",
  //i18n.t("login-error")
  login_error: "login-error",
};

export const ENUMLOGINSTATUS_OPTION: {
  value: EnumLoginStatus;
  label: I18nKey;
}[] = [
  {
    value: "login_success",
    label: "login-success",
  },
  {
    value: "login_bad_credentials",
    label: "login-bad-credentials",
  },
  {
    value: "login_unknown_account",
    label: "login-unknown-account",
  },
  {
    value: "login_error",
    label: "login-error",
  },
];

// EnumDeviceCategory
export const ENUM_DEVICE_CATEGORY = [
  "desktop",
  "mobile",
  "tablet",
  "unknown_device",
] as const;

export type EnumDeviceCategory = (typeof ENUM_DEVICE_CATEGORY)[number];

export const enumdevicecategoryToI18nKey: Record<EnumDeviceCategory, I18nKey> =
  {
    //i18n.t("desktop")
    desktop: "desktop",
    //i18n.t("mobile")
    mobile: "mobile",
    //i18n.t("tablet")
    tablet: "tablet",
    //i18n.t("unknown-device")
    unknown_device: "unknown-device",
  };

export const ENUMDEVICECATEGORY_OPTION: {
  value: EnumDeviceCategory;
  label: I18nKey;
}[] = [
  {
    value: "desktop",
    label: "desktop",
  },
  {
    value: "mobile",
    label: "mobile",
  },
  {
    value: "tablet",
    label: "tablet",
  },
  {
    value: "unknown_device",
    label: "unknown-device",
  },
];

// EnumLicenseAction
export const ENUM_LICENSE_ACTION = [
  "license_granted",
  "license_revoked",
] as const;

export type EnumLicenseAction = (typeof ENUM_LICENSE_ACTION)[number];

export const enumlicenseactionToI18nKey: Record<EnumLicenseAction, I18nKey> = {
  //i18n.t("license-granted")
  license_granted: "license-granted",
  //i18n.t("license-revoked")
  license_revoked: "license-revoked",
};

export const ENUMLICENSEACTION_OPTION: {
  value: EnumLicenseAction;
  label: I18nKey;
}[] = [
  {
    value: "license_granted",
    label: "license-granted",
  },
  {
    value: "license_revoked",
    label: "license-revoked",
  },
];
